import { FlightConfig } from '../../store/schema/NinjaFlightsResponse';
import { getStore } from '../../store/store';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import onFeatureFlagsPaneOpened from '../../actions/onFeatureFlagsPaneOpened';
import onFlightConfigSelected from '../../actions/onFlightConfigSelected';
import { Link } from 'office-ui-fabric-react/lib/Link';

const styles = require('./FeatureFlagsHeader.scss');

export default observer(function FeatureFlagsHeader() {
    React.useEffect(() => {
        onFeatureFlagsPaneOpened();
    }, []);

    const dropdownItems: IDropdownOption[] = React.useMemo<IDropdownOption[]>(
        () => [
            // Default flight config
            {
                key: 'DEFAULT',
                text: 'Default flags',
            },
            // Dogfood flight config
            {
                key: 'DOGFOOD',
                text: 'Dogfood feature flags',
            },
            // Microsoft flight config
            {
                key: 'MICROSOFT',
                text: 'Microsoft feature flags',
            },
            // WW flight config
            {
                key: 'WW',
                text: 'WW feature flags',
            },
        ],
        []
    );

    const resetToDefaults = React.useCallback(() => {
        onFlightConfigSelected('DEFAULT');
    }, []);

    return (
        <div className={styles.container}>
            <Link onClick={resetToDefaults} styles={{ root: { marginBottom: '5px' } }}>
                Reset to default flags
            </Link>
            <Dropdown
                onChange={onFlightConfigChange}
                options={dropdownItems}
                selectedKey={getStore().selectedFlightConfig}
                styles={{
                    root: {
                        width: '100%',
                    },
                }}
            />
        </div>
    );
});

/**
 * Handler for when user selects a flight config option from the dropdown.
 */
function onFlightConfigChange(event: any, option: IDropdownOption) {
    const { key: selectedFlightConfig } = option;
    onFlightConfigSelected(selectedFlightConfig as FlightConfig);
}
